export const profile = {
  name: "Ansh Jatana",
  firstName: "Ansh",
  title: "Frontend Engineer",
  email: "anshjatana1111@gmail.com",
  location: "Gurugram",
  tagline: "Frontend engineer building products that ship.",
  github: "https://github.com/Anshjatana",
};

export const navLinks = [
  { id: "home", link: "home", label: "Home" },
  { id: "about", link: "about", label: "About" },
  { id: "experience", link: "experience", label: "Experience" },
  { id: "projects", link: "projects", label: "Projects" },
  { id: "contact", link: "contact", label: "Contact" },
];

export const socialLinks = [
  {
    id: "github",
    label: "GitHub",
    value: "@Anshjatana",
    href: "https://github.com/Anshjatana",
  },
  {
    id: "linkedin",
    label: "LinkedIn",
    value: "Ansh Jatana",
    href: "https://www.linkedin.com/in/ansh-jatana-10b446205/",
  },
  {
    id: "twitter",
    label: "Twitter",
    value: "@anshh_jatana",
    href: "https://twitter.com/anshh_jatana",
  },
  {
    id: "email",
    label: "Email",
    value: "anshjatana1111@gmail.com",
    href: "mailto:anshjatana1111@gmail.com",
  },
];

export const scrollConfig = {
  duration: 900,
  smooth: true,
};
